export const validationErrors = (val) => ({
  isMacAddress: "Please enter valid MAC address"
})

export const validationChecks = {
  isMacAddress(_, field) {
    if (field) {
      const valid = /^([0-9A-Fa-f]{2}[:-]?){5}([0-9A-Fa-f]{2})$/.test(field);
    
      if (!valid) {
        return "Please input valid mac address"
      }
    }
    
    return true;
  },
}